import { api } from './client'

export type ArquivoNaLista = {
  id: number
  titulo: string
  descricao: string | null
  categoria: string
  nomeOriginal: string
  mime: string
  bytes: number
  ativo: boolean
  criadoEm: string
  criadoPor: string
  atualizadoEm: string | null
  atualizadoPor: string | null
}

export type CategoriaNoBanco = { categoria: string; total: number }

const raiz = (marca: string) => `/marcas/${encodeURIComponent(marca)}/arquivos`

/**
 * 🔴 O link vem **relativo** do servidor (`/arquivos/...`), e é assim que ele
 * precisa ser guardado — o domínio da API não pertence ao domínio.
 *
 * Mas o que o atendente cola na conversa vai para **fora**: colar um caminho
 * relativo produz um link que não abre em lugar nenhum, e o cliente recebe algo
 * quebrado sem ninguém perceber deste lado. A URL absoluta é montada aqui, na
 * borda, que é onde a origem existe.
 */
export function absoluto(link: string) {
  const base = import.meta.env.VITE_API_URL ?? window.location.origin

  return `${base.replace(/\/$/, '')}${link}`
}

export const arquivos = {
  listar: (marca: string, filtro?: { termo?: string; categoria?: string; incluirInativos?: boolean }) => {
    const busca = new URLSearchParams()

    if (filtro?.termo) busca.set('termo', filtro.termo)
    if (filtro?.categoria) busca.set('categoria', filtro.categoria)
    if (filtro?.incluirInativos) busca.set('incluirInativos', 'true')

    const consulta = busca.toString()

    return api.get<ArquivoNaLista[]>(`${raiz(marca)}${consulta ? `?${consulta}` : ''}`)
  },

  categorias: (marca: string) => api.get<CategoriaNoBanco[]>(`${raiz(marca)}/categorias`),

  /** Pré-visualização na tela — exige sessão, ao contrário do link que vai ao cliente. */
  conteudo: (marca: string, id: number) =>
    `${import.meta.env.VITE_API_URL ?? ''}${raiz(marca)}/${id}/conteudo`,

  link: (marca: string, id: number) =>
    api.get<{ link: string; nomeOriginal: string; titulo: string }>(`${raiz(marca)}/${id}/link`),

  publicar: (
    marca: string,
    dados: { titulo: string; categoria: string; descricao: string; arquivo: File },
  ) => {
    const corpo = new FormData()

    corpo.append('titulo', dados.titulo)
    corpo.append('categoria', dados.categoria)
    corpo.append('descricao', dados.descricao)
    corpo.append('arquivo', dados.arquivo)

    return api.enviarFormulario<{ id: number; titulo: string }>(raiz(marca), corpo)
  },

  salvar: (
    marca: string,
    id: number,
    dados: { titulo: string; descricao: string | null; categoria: string; ativo: boolean },
  ) => api.put<{ id: number; titulo: string; ativo: boolean }>(`${raiz(marca)}/${id}`, dados),

  apagar: (marca: string, id: number) => api.delete<void>(`${raiz(marca)}/${id}`),
}
